import React, { useEffect, useState } from "react";
import { Layout, Menu, Button } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import * as AntIcons from "@ant-design/icons";
import logo from "../Assets/logo.svg"
import logoNew from "../Assets/ldclogo.png"
import icon1 from '../Assets/dashboard-line.png'
import icon2 from '../Assets/money-pound-box-line.png'
import icon3 from '../Assets/empathize-line.png'
import icon4 from '../Assets/health-book-line.png'
import icon5 from '../Assets/hearts-line.png'
import icon6 from '../Assets/hospital-line.png'
import icon7 from '../Assets/close-circle-line.png'
import icon8 from '../Assets/loop-right-fill.png'
import icon9 from '../Assets/wallet-2-line.png'
import icon10 from '../Assets/user-settings-line@2x.png'
import icon11 from '../Assets/mail-line.png'
import icon12 from '../Assets/chat-3-line.png'
import icon13 from '../Assets/alert-line.png'
import icon14 from '../Assets/apps-line.png'
import icon15 from '../Assets/user-3-line.png'
import icon16 from '../Assets/user-2-line.png'
import icon17 from '../Assets/audit.png'
import './LayoutMobile.css'
import SlotCountdownInline from "./Alerts/SlotCountdown";

// Renders a dynamic Ant Design icon by name (e.g. "CalendarOutlined").
// Falls back to AppstoreOutlined if icon_name is not found.
const DynamicIcon = ({ name, style }) => {
    const IconComponent = (name && AntIcons[name]) ? AntIcons[name] : AntIcons['AppstoreOutlined'];
    return <IconComponent style={{ fontSize: 14, color: '#008385', ...style }} />;
};
const { Header, Sider, Content } = Layout;

const App = (props) => {
    // console.log('props ::::',props)
    let userTempData = localStorage.getItem('userData'), userData = {}
    if (userTempData) {
        userData = JSON.parse(userTempData)
    }
    // const userRole = userData?.roles[0]?.role_id; 
    const userRole = userData?.roles?.[0]?.role_id;
    // console.log("LayoutMobile_userRole:::", userRole );

    const isCSRandCSR_R = userRole === 2 || userRole === 3;
    const isCorporateAdmin = userRole === 4;
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedKey, setSelectedKey] = useState(null);


    // ─── Sub-category routes that belong to the Product Categories submenu ────
    const PRODUCT_CAT_ROUTES = ['/product-categories', '/product-category', '/corporate-product', '/gp-product-admin'];
    const isCatSubRoute = PRODUCT_CAT_ROUTES.some(r => location.pathname.startsWith(r));

    // ─── Sub-routes that belong to the User Management submenu ───────────────
    const USER_MGMT_ROUTES = ['/user-management', '/user-management/patients'];
    const isUserMgmtSubRoute = USER_MGMT_ROUTES.some(r => location.pathname === r || location.pathname.startsWith(r + '/'));

    // openKeys drives which submenus are expanded; '3' = Product Categories, '11' = User Management
    const [openKeys, setOpenKeys] = useState([
        ...(isCatSubRoute ? ['3'] : []),
        ...(isUserMgmtSubRoute ? ['11'] : []),
    ]);

    const handleOpenChange = (keys) => {
        setOpenKeys(keys);
    };
    let showCategoryTemp = localStorage.getItem('showCategory')
    const [productCategories, setproductCategories] = useState(showCategoryTemp ? JSON.parse(showCategoryTemp) : null);

    // Re-sync sidebar when localStorage.showCategory changes after a drag reorder
    useEffect(() => {
        const syncFromStorage = () => {
            const raw = localStorage.getItem('showCategory');
            if (raw) {
                try { setproductCategories(JSON.parse(raw)); } catch (_) { }
            }
        };
        // Native storage event (cross-tab)
        window.addEventListener('storage', syncFromStorage);
        // Custom event dispatched by NewProductCategory after PUT reorder
        window.addEventListener('categoryOrderUpdated', syncFromStorage);
        return () => {
            window.removeEventListener('storage', syncFromStorage);
            window.removeEventListener('categoryOrderUpdated', syncFromStorage);
        };
    }, []);

    useEffect(() => {
        // Auto-expand Product Categories submenu when on any sub-route
        if (PRODUCT_CAT_ROUTES.some(r => location.pathname.startsWith(r))) {
            setOpenKeys(prev => prev.includes('3') ? prev : [...prev, '3']);
        }
    }, [location.pathname]);

    useEffect(() => {
        // Auto-expand User Management submenu when on any sub-route
        if (USER_MGMT_ROUTES.some(r => location.pathname === r || location.pathname.startsWith(r + '/'))) {
            setOpenKeys(prev => prev.includes('11') ? prev : [...prev, '11']);
        }
    }, [location.pathname]);

    useEffect(() => {
        if (props.productCategories) {
            // console.log('props.productCategories ::', props.productCategories)
            setproductCategories(props.productCategories)

        }
    }, [props?.productCategories])

    // ─── Type → route mapping (IOO-300) ──────────────────────────────────
    const getHrefForCategory = (cat) => {
        switch (cat.type) {
            case 'gp': return `/gp-product-admin`;
            case 'd2c': return `/product-category?categoryId=${cat.product_category_id}`;
            case 'corporate': return `/corporate-product?categoryId=${cat.product_category_id}`;
            default: return `/product-categories?categoryId=${cat.product_category_id}`;
        }
    };

    // ─── Dynamic category submenu children ───────────────────────────────
    // productCategories is keyed by product_category_id: { 1: {...}, 2: {...}, ... }
    const buildCategoryChildren = (startKey = 200) => {
        if (!productCategories || !Object.keys(productCategories).length) return [];
        // Sort by sort_order (if present) so submenu reflects drag-and-drop order
        const sorted = Object.values(productCategories).sort((a, b) => {
            const oa = a.sort_order ?? 9999;
            const ob = b.sort_order ?? 9999;
            return oa - ob;
        });
        return sorted.map((cat, idx) => {
            return {
                key: `cat-${cat.product_category_id || startKey + idx}`,
                href: getHrefForCategory(cat),
                className: 'sidebarSubMenuNew',
                label: (
                    <span className="cat-submenu-item">
                        <span className="cat-icon-wrap">
                            <DynamicIcon name={cat.icon_name} />
                        </span>
                        <span className="cat-name">{cat.name || 'Category'}</span>
                    </span>
                ),
            };
        });
    };

    const CSRAndCSRR_Menu = [
        { key: '1', label: "Dashboard", href: "/dashboard", icon: <img src={icon1} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '2', label: "GP Pricing Matrix", href: "/gp-pricing", icon: <img src={icon2} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '6', label: "Clinician Profile", href: "/clinician-profile", icon: <img src={icon3} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        // { key: '22', label: "Abandoned Journeys", href: "/abandoned-journey", icon: <img src={icon17} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '16', label: "Profile", href: "/profile", icon: <img src={icon15} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
    ];

    const CSRMenu = [
        { key: '1', label: "Dashboard", href: "/dashboard", icon: <img src={icon1} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        {
            key: '3',
            label: (
                <span
                    className="cat-parent-label"
                    onClick={(e) => { e.stopPropagation(); navigate('/product-categories'); }}
                >
                    Product Categories
                </span>
            ),
            href: "/product-categories",
            icon: <img src={icon4} />,
            style: { textAlign: 'left' },
            className: "sidebarMenu",
            children: buildCategoryChildren(200),
        },
        { key: '8', label: "Cancellation Rules", href: "/cancellation-rules", icon: <img src={icon7} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '9', label: "Rescheduling Rules", href: "/rescheduling-rules", icon: <img src={icon8} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '19', label: "Corporate Customer", href: "/corporate-customer", icon: <img src={icon16} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '23', label: "Partner", href: "/partner", icon: <img src={icon16} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '16', label: "Profile", href: "/profile", icon: <img src={icon15} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
    ];


    const AdminMenus = [
        { key: '1', label: "Dashboard", href: "/dashboard", icon: <img src={icon1} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '2', label: "GP Pricing Matrix", href: "/gp-pricing", icon: <img src={icon2} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '17', label: "GP Product Admin", href: "/gp-product-admin", icon: <img src={icon5} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        {
            key: '3',
            label: (
                <span
                    className="cat-parent-label"
                    onClick={(e) => { e.stopPropagation(); navigate('/product-categories'); }}
                >
                    Product Categories
                </span>
            ),
            href: "/product-categories",
            icon: <img src={icon4} />,
            style: { textAlign: 'left' },
            className: "sidebarMenu",
            children: buildCategoryChildren(300),
        },
        { key: '6', label: "Clinician Profile", href: "/clinician-profile", icon: <img src={icon3} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '7', label: "Clinic Settings", href: "/clinic-settings", icon: <img src={icon6} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '8', label: "Cancellation Rules", href: "/cancellation-rules", icon: <img src={icon7} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '9', label: "Rescheduling Rules", href: "/rescheduling-rules", icon: <img src={icon8} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '10', label: "Payment Settings", href: "/payment-settings", icon: <img src={icon9} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        {
            key: '11',
            label: (
                <span
                    className="cat-parent-label"
                    onClick={(e) => { e.stopPropagation(); navigate('/user-management'); }}
                >
                    User Management
                </span>
            ),
            href: '/user-management',
            icon: <img src={icon15} />,
            style: { textAlign: 'left' },
            className: 'sidebarMenu',
            children: [
                {
                    key: 'um-patients',
                    href: '/user-management/patients',
                    className: 'sidebarSubMenuNew',
                    label: (
                        <span className="cat-submenu-item">
                            <span className="cat-icon-wrap">
                                <AntIcons.MedicineBoxOutlined style={{ fontSize: 14, color: '#008385' }} />
                            </span>
                            <span className="cat-name">Patients</span>
                        </span>
                    ),
                },
            ],
        },
        { key: '12', label: "GP Patient Email Copy", href: "/generic-email-copy", icon: <img src={icon11} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '21', label: "Admin Email Copy", href: "/email-admin", icon: <img src={icon11} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '13', label: "GP SMS Copy", href: "/generic-sms-copy", icon: <img src={icon12} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '14', label: "Alert", href: "/alert", icon: <img src={icon13} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '15', label: "Other", href: "/others", icon: <img src={icon14} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '19', label: "Corporate Customer", href: "/corporate-customer", icon: <img src={icon16} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '23', label: "Partner", href: "/partner", icon: <img src={icon16} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '20', label: "Audit Logs", href: "/audit-logs", icon: <img src={icon17} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        // { key: '22', label: "Abandoned Journeys", href: "/abandoned-journey", icon: <img src={icon17} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '16', label: "Profile", href: "/profile", icon: <img src={icon15} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
    ];

    // const menus = userRole === 1 ? AdminMenus : isCSRandCSR_R ? CSRAndCSRR_Menu : [];

    let menus = [];

    switch (true) {
        case userRole === 1:
            menus = AdminMenus;
            break;

        case isCSRandCSR_R:
            menus = CSRAndCSRR_Menu;
            break;

        case isCorporateAdmin:
            menus = CSRMenu;
            break;

        default:
            menus = [];
            break;
    }

    const handleMenuClick = ({ item, key, keyPath, domEvent }) => {
        setSelectedKey(key);
        if (keyPath && keyPath.length >= 2) {
            // Child item clicked — search all menus for the child
            const parentItem = menus.find((m) => m.key === keyPath[keyPath.length - 1]);
            if (parentItem) {
                const childItem = parentItem.children?.find((c) => c.key === key);
                if (childItem?.href) {
                    navigate(childItem.href);
                    return;
                }
            }
        }
        // Top-level item
        const menuItem = menus.find((m) => m.key === key);
        if (menuItem?.href) {
            navigate(menuItem.href);
        }
    };
    return (
        <>
            <Layout style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
                {/* Navbar */}
                <Header
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "white",
                        padding: "0 20px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                        // background: "#fff"
                    }}
                >


                    <div style={{ color: "black", margin: 0, fontSize: "20px", marginLeft: "auto", display: 'flex', alignItems: 'center' }}>


                        {/* <SlotCountdownInline /> */}
                        <div style={{ color: "black", margin: " 0 0 0 10px ", fontSize: "20px", marginLeft: "auto", fontWeight: 'bold' }}>
                            {/* <SlotCountdown expiresAt={localStorage.getItem('bookingExpiresAt')} /> here render  */}

                            Hi,<span style={{ fontSize: "20px", fontWeight: 'normal' }}> {userData?.name} </span>
                        </div>
                    </div>

                </Header>
                {/* Sidebar */}
                <Layout >
                    <Sider
                        width={250}
                        theme="dark"
                        style={{ borderRight: "2px solid #fff", background: "#fff", marginTop: "-5%", position: "relative" }}
                        className="dashboardSidebar"
                    >
                        <div style={{
                            width: '250px',
                            height: '133px',
                            backgroundColor: '#008385',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}

                        >
                            <img
                                src={logoNew}
                                alt="Logo"
                                style={{
                                    width: '100%',  // Makes it responsive 
                                    maxWidth: '193px',
                                    height: 'auto',
                                    transition: "width 0.3s ease"
                                }}
                            />
                        </div>
                        <Menu
                            theme="light"
                            mode="inline"
                            color="white"
                            selectedKeys={(() => {
                                const fullPath = location.pathname + location.search;
                                // 1. Category sub-items — match pathname+search against computed href
                                if (productCategories) {
                                    for (const cat of Object.values(productCategories)) {
                                        const href = getHrefForCategory(cat);
                                        if (fullPath === href || location.pathname === href) {
                                            return [`cat-${cat.product_category_id}`];
                                        }
                                    }
                                }
                                // 2. User Management children
                                if (location.pathname === '/user-management/patients') return ['um-patients'];
                                // 3. Top-level items — exact pathname match
                                for (const m of menus) {
                                    if (m.href && !m.children && location.pathname === m.href) return [m.key];
                                }
                                // 4. Product Categories overview page
                                if (location.pathname === '/product-categories') return ['3'];
                                return [selectedKey];
                            })()}
                            openKeys={openKeys}
                            onOpenChange={handleOpenChange}
                            onClick={handleMenuClick}
                            style={{ borderRight: "none", fontSize: "15px", color: "white" }}
                            items={menus}
                            className="sidebarNav"
                        >
                            {/* {menus.map((item, index) => (
                            <Menu.Item key={item.label} icon={item.icon} style={{ textAlign: 'left', marginTop: '47px' }}>
                                <Link style={{ color: "#000", textAlign: 'left' }} to={item.href} >{item.label}</Link>
                            </Menu.Item>
                        ))} */}
                        </Menu>

                    </Sider>
                    <Layout style={{ padding: "20px", background: "#eef1f5" }}>
                        <Content
                            style={{
                                background: "#f0fafa",
                                padding: 30,
                                borderRadius: 10,
                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            {props.children}
                        </Content>
                    </Layout>
                </Layout>
            </Layout>

        </>
    );
};

export default App;